import { Link } from "react-router-dom";
import "./notFoundPage.css";
export default function NotFoundPage() {
    return (
        <div className='notFoundPage'>
            <div className="text-center">
                <h3 className="fs50">404 Page not Found </h3>
                <Link to={"/home"} className="">
                    <button className='notfound_btn fs20'>Back To Home</button>
                </Link>
            </div>
        </div>
    )
}